'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goBackwards = goBackwards;
exports.learnMore = learnMore;
exports.closeModal = closeModal;
exports.close = close;
exports.selectProvider = selectProvider;
exports.chooseProvider = chooseProvider;
exports.compareProviders = compareProviders;
exports.openSupportDialog = openSupportDialog;
exports.closeHelp = closeHelp;

var _actionsTypeConsts = require('./actionsTypeConsts.js');

var _actionsTypeConsts2 = _interopRequireDefault(_actionsTypeConsts);

var _reactRouterRedux = require('react-router-redux');

var _closeChooseProviderReasons = require('./components/closeChooseProviderReasons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function goBackwards() {
  return (0, _reactRouterRedux.goBack)();
}

function learnMore(provider) {
  return {
    type: _actionsTypeConsts2.default.learnMore,
    payload: provider
  };
}

function closeModal() {
  return {
    type: _actionsTypeConsts2.default.closeAlert
  };
}

function close() {
  var closeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _closeChooseProviderReasons.closeReasons.cancel;

  return {
    type: _actionsTypeConsts2.default.close,
    payload: { closeType: closeType }
  };
}

function selectProvider(provider) {
  return {
    type: _actionsTypeConsts2.default.selectProvider,
    payload: provider
  };
}

function chooseProvider(provider) {
  return {
    type: _actionsTypeConsts2.default.chooseProvider,
    payload: provider
  };
}

function compareProviders() {
  return {
    type: _actionsTypeConsts2.default.compareProviders
  };
}

function openSupportDialog(supportLink) {
  return {
    type: _actionsTypeConsts2.default.openHelp,
    payload: supportLink
  };
}

function closeHelp() {
  return {
    type: _actionsTypeConsts2.default.closeHelp
  };
}